import * as Sentry from '@sentry/react';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';

import * as config from 'config';
import { store } from 'store';
import App from './App';

// Sentry sample rate
const sampleRate = config.isDev ? 1.0 : 0.1;

// Init Sentry
Sentry.init({
  dsn: config.sentryDsn,
  environment: config.environment,
  release: config.sentryRelease,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration({
      networkDetailAllowUrls: [
        globalThis.location.origin,
        'localhost',
        'https://bff.dev-mypages.dss.husqvarnagroup.net/v1',
        'https://bff.qa-mypages.dss.husqvarnagroup.net/v1',
        'https://bff.qa-mypages-construction.dss.husqvarnagroup.net/v1',
        'https://bff.mypages.husqvarna.com/v1',
        'https://bff.mypages.husqvarnaconstruction.com/v1'
      ],
      networkCaptureBodies: true,
      networkResponseHeaders: ['x-amzn-requestid', 'x-external-requestid']
    })
  ],
  // Performance Monitoring
  tracesSampleRate: sampleRate,
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: [
    'localhost',
    'https://bff.dev-mypages.dss.husqvarnagroup.net/v1',
    'https://bff.qa-mypages.dss.husqvarnagroup.net/v1',
    'https://bff.qa-mypages-construction.dss.husqvarnagroup.net/v1',
    'https://bff.mypages.husqvarna.com/v1',
    'https://bff.mypages.husqvarnaconstruction.com/v1'
  ],
  // Session Replay
  replaysSessionSampleRate: sampleRate,
  replaysOnErrorSampleRate: 1.0
});

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>
);
